import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const Registeration = (personalInfo) => {
    return vdkHappinessPortalApi.post(`personalInfo/person-registration`, personalInfo);
};
const DirectorOrExternalRegisteration = (personalInfo) => {
    return vdkHappinessPortalApi.post(`personalInfo/director-external-registration`, personalInfo);
};
const GetPersonalInfoByUserId = (request) => {
    return vdkHappinessPortalApi.post(`personalInfo/get-person-by-userId`, request);
};
const PersonalInfoApi = {
    Registeration,
    DirectorOrExternalRegisteration,
    GetPersonalInfoByUserId,
};
export default PersonalInfoApi;
